import { Money } from '@ap/interface-bspc-core';
import { PurchaseCost, PurchaseCostDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class PurchaseCostBuilder {
    private amount: Money;
    private detail: PurchaseCostDetail;

    withAmount(amount: Money): this {
        this.amount = amount;
        return this;
    }

    withDetail(detail: PurchaseCostDetail): this {
        this.detail = detail;
        return this;
    }

    build(): PurchaseCost {
        return {
            amount: this.amount,
            detail: this.detail
        } as PurchaseCost;
    }
}

export const aPurchaseCost = new PurchaseCostBuilder();
